<template>
  <card>
    <b-row>
      <b-col cols="10">
        <b-form class="row" v-on:submit.prevent="doFilter">
          <b-col md="3">
            <el-input class="input-primary" placeholder="Filter By Name" clearable v-model="tableFilter.name"/>
          </b-col>
          <b-col md="1">
            <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/> Search</button>
          </b-col>
        </b-form>
      </b-col>
      <b-col cols="2">
        <create-new-data :data-url="'/pembelian/create'" :clearfix="false"/>
      </b-col>
      <b-col cols="12 mb-1">
        <div class="d-flex align-items-center h-100">
          <el-checkbox v-model="fakeTableFilter.is_active">Active Only</el-checkbox>
        </div>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :param-no-uuid="true"  :active-url="apiUrl" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['is_active','name']">
      <template slot="content_created_by" slot-scope="defaultSlotScope">
        <a :href="'#/users/' + defaultSlotScope.rowData.created_by.id">{{defaultSlotScope.rowData.created_by.name}}</a>
      </template>
      <template slot="content_po_date" slot-scope="defaultSlotScope">
        {{getDate(defaultSlotScope.rowData.po_date)}}
      </template>
      <template slot="content_status" slot-scope="defaultSlotScope">
        <b-badge :variant="getStatusColor(defaultSlotScope.rowData.status)">{{getStatus(defaultSlotScope.rowData.status)}}</b-badge>
      </template>
      <template slot="content_supplier" slot-scope="defaultSlotScope">
        <a :href="'#/pengaturan/supplier/' + defaultSlotScope.rowData.supplier.id">{{defaultSlotScope.rowData.supplier.name}}</a>
      </template>
      <template slot="content_last_updated_by" slot-scope="defaultSlotScope">
        <a :href="'#/users/' + defaultSlotScope.rowData.last_updated_by.id">{{defaultSlotScope.rowData.last_updated_by.name}}</a>
      </template>
    </paginated-table>
  </card>
</template>
<script>
  import { Input, Checkbox } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import CreateNewData from '@/components/Buttons/CreateNewData'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      CreateNewData,
      elCheckbox: Checkbox
    },
    data () {
      return {
        dataKey: 'supplier-po',
        apiUrl: window.AppConfig.apiUrl + 'supplier-po',
        columns: [
          {
            prop: 'supplier',
            label: 'Supplier',
            sortable: true
          },
          {
            prop: 'po_date',
            label: 'Tgl PO'
          },
          {
            prop: 'status',
            label: 'Status'
          },
          {
            prop: 'created_by',
            label: 'Dibuat Oleh'
          },
          {
            prop: 'last_updated_by',
            label: 'Diperbarui Oleh'
          }
        ],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          name: this.$route.query.name
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      getColorStatus (status) {
        if (status === 'Canceled') {
          return 'dark'
        } else if (status === 'Paid') {
          return 'success'
        } else if (status === 'Invoice') {
          return 'primary'
        } else if (status === 'Working') {
          return 'warning'
        } else if (status === 'New') {
          return 'info'
        } else {
          return 'danger'
        }
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Dipesan'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Diterima'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Dibatalkan'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getDate (value) {
        return this.$moment(value).format('DD-MM-YYYY')
      }
    },
    mounted () {
      // this.initData().requestCategory()
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Pos/Index.vue